import React, { useEffect, useState } from 'react';
import Layout from './layout';
import { getCourses, createCourse, updateCourse, deleteCourse } from './api/courseApi';

function CoursesPage() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({ title: '' });
  const [editId, setEditId] = useState(null);

  const fetchCourses = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await getCourses();
      setCourses(data.courses || data); // support both array and {courses: []}
    } catch (err) {
      setError('Failed to fetch courses');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCourses();
  }, []);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAdd = () => {
    setFormData({ title: '' });
    setEditId(null);
    setShowForm(true);
  };

  const handleEdit = (course) => {
    setFormData({
      title: course.title || '',
    });
    setEditId(course.id);
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this course?')) return;
    try {
      await deleteCourse(id);
      fetchCourses();
    } catch {
      setError('Failed to delete course');
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editId) {
        await updateCourse(editId, formData);
      } else {
        await createCourse(formData);
      }
      setShowForm(false);
      fetchCourses();
    } catch {
      setError('Failed to save course');
    }
  };

  return (
    <Layout>
      <div className="container p-4">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <h2>Courses</h2>
          <button className="btn btn-primary" onClick={handleAdd}>Add Course</button>
        </div>
        {error && <div className="alert alert-danger">{error}</div>}
        {loading ? (
          <div>Loading...</div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Title</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {courses.length === 0 && (
                <tr><td colSpan={2} className="text-center">No courses found.</td></tr>
              )}
              {courses.map((course) => (
                <tr key={course.id}>
                  <td>{course.title}</td>
                  <td>
                    <button className="btn btn-sm btn-secondary me-2" onClick={() => handleEdit(course)}>Edit</button>
                    <button className="btn btn-sm btn-danger" onClick={() => handleDelete(course.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}

        {/* Modal/Form for Add/Edit */}
        {showForm && (
          <div className="modal show d-block" tabIndex="-1" role="dialog" style={{background: 'rgba(0,0,0,0.3)'}}>
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <form onSubmit={handleFormSubmit}>
                  <div className="modal-header">
                    <h5 className="modal-title">{editId ? 'Edit Course' : 'Add Course'}</h5>
                    <button type="button" className="btn-close" onClick={() => setShowForm(false)} aria-label="Close"></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Title</label>
                      <input type="text" className="form-control" name="title" value={formData.title || ''} onChange={handleInputChange} required />
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="button" className="btn btn-secondary" onClick={() => setShowForm(false)}>Cancel</button>
                    <button type="submit" className="btn btn-primary">Save</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}

export default CoursesPage; 